import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=66e0b219"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"
import style0 from "./Controls.vue?vue&type=style&index=0&id=66e0b219&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports